import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd46f85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "video-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "player-instance" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import Player from 'xgplayer'
import 'xgplayer/dist/index.min.css'
import HlsPlugin from 'xgplayer-hls'
import Mp4Plugin from 'xgplayer-mp4'
import { onMounted, onUnmounted, ref, watch } from 'vue'

const playerId = 'player-instance'
const containerId = 'video-container'

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  props: {
    url: {}
  },
  setup(__props: any) {

const props = __props
const videoUrl = ref(props.url)
ref<Player | null>(null)
let player: Player

function isSupportedFormat (url: string): boolean {
  const extension = url.split('.').pop()?.toLowerCase()
  return extension === 'm3u8' || extension === 'mp4'
}

function initializePlayer (url: string, width: number, height: number) {
  return new Promise<void>((resolve, reject) => {
    const extension = url.split('.').pop()?.toLowerCase()
    const playerElement = document.getElementById(playerId) as HTMLElement | null

    if (playerElement) {
      if (player) {
        player.destroy()
      }

      player = new Player({
        id: playerId,
        url,
        autoplay: true,
        fitVideoSize: 'fixWidth',
        cssFullscreen: false,
        width,
        height,
        plugins: extension === 'm3u8' ? [HlsPlugin] : [Mp4Plugin]
      })

      // Ensure player is fully initialized before resolving
      setTimeout(() => {
        const playerElement = document.getElementById(playerId)
        if (playerElement) {
          resolve()
        } else {
          console.error('Player element not found after initialization.')
          reject(new Error('Player element not found'))
        }
      }, 500) // Adjust timeout if needed
    } else {
      console.error('Player element not found.')
      reject(new Error('Player element not found'))
    }
  })
}

function observeContainerSize () {
  const container = document.getElementById(containerId) as HTMLElement | null

  if (container) {
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const {
          width,
          height
        } = entry.contentRect

        // Update player dimensions
        if (player) {
          // Adjust player element size
          const playerElement = document.getElementById(playerId) as HTMLElement | null
          if (playerElement) {
            playerElement.style.width = `${width}px`
            playerElement.style.height = `${height}px`
          }
        }
      }
    })

    resizeObserver.observe(container)

    onUnmounted(() => {
      if (container) {
        resizeObserver.unobserve(container)
      }
    })
  } else {
    console.error('Container element not found for size observation.')
  }
}

onMounted(() => {
  if (isSupportedFormat(videoUrl.value)) {
    const container = document.getElementById(containerId) as HTMLElement | null
    if (container) {
      const width = container.offsetWidth
      const height = container.offsetHeight
      initializePlayer(videoUrl.value, width, height).catch((error) => {
        console.error('Error initializing player:', error)
      })
    } else {
      console.error('Container element not found on mount.')
    }
  } else {
    console.error('Invalid format on mount.')
  }

  watch(() => props.url, (newUrl) => {
    videoUrl.value = newUrl
    const container = document.getElementById(containerId) as HTMLElement | null
    if (container) {
      const width = container.offsetWidth
      const height = container.offsetHeight
      if (player) {
        player.destroy()
      }
      if (isSupportedFormat(videoUrl.value)) {
        initializePlayer(videoUrl.value, width, height).catch((error) => {
          console.error('Error initializing player:', error)
        })
      }
    }
  })

  observeContainerSize()
})

onUnmounted(() => {
  if (player) {
    player.destroy()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})